import React, { useState } from 'react';
import '../styles.css';

const DatosFactOk = ({ onContinuar }) => {
  const [form, setForm] = useState({ aceptaTerminos: true });

  // 👇 Ajusta estas URLs a lo que necesites
  const WA_URL = 'https://wa.me/15533321410';
  const ROTP_URL = 'https://www.rotoplas.com';

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };

  const abrirEnNuevaPestana = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleVolverWhats = () => {
    onContinuar?.({});               // opcional: si quieres disparar el callback
    abrirEnNuevaPestana(WA_URL);     // o usa: window.location.assign(WA_URL) para misma pestaña
  };

  const handleVisitarRotoplas = () => {
    abrirEnNuevaPestana(ROTP_URL);   // o usa: window.location.assign(ROTP_URL)
  };

  return (
    <div className="contenedor-formulario">
      <div className="succes-page">
        <h2 className="titulo-seccion" style={{ textAlign:'center' }}>✅ Datos recibidos</h2>
        <p>Gracias por completar tu información de facturación 🧾</p>
        <p>Tu factura será enviada a tu correo en los próximos días.</p>
        <p style={{ fontWeight:'bold' }}>Por favor, mantente atento a tu bandeja de entrada 📩</p>
        <p>Gracias por pedir con Rotoplas Express ⚡</p>

        <button type="button" className="boton-next" onClick={handleVolverWhats}>
          Volver a WhatsApp
        </button>

        <button type="button" className="boton-rotoplas" onClick={handleVisitarRotoplas}>
          Visitar rotoplas.com
        </button>
      </div>
    </div>
  );
};

export default DatosFactOk;
